
import { defineComponent, PropType } from 'vue'
import { PPTLatexElement } from '@/types/slides'

export default defineComponent({
  name: 'base-element-latex',
  props: {
    elementInfo: {
      type: Object as PropType<PPTLatexElement>,
      required: true,
    },
  },
})
